import React, { useEffect, useRef } from 'react';
import { Collapse } from 'reactstrap';
import { initGeosegmentationHtmlElProps } from '../../services/geoSegmentationService';
import BgTransitionAnimation from '../../shared/bgTransitionAnimation';
import TextMediaAccordionItemContent from './textMediaAccordionItemContent';
import TextMediaAccordionItemTitle from './textMediaAccordionItemTitle';
export default function TextMediaAccordionItem(props) {
    var item = props.item, itemIndex = props.itemIndex, index = props.index, setItemIndex = props.setItemIndex, children = props.children, setActiveImgIndex = props.setActiveImgIndex, activeImgIndex = props.activeImgIndex, moveUpMobile = props.moveUpMobile;
    var refItems = useRef(null);
    useEffect(function () {
        initGeosegmentationHtmlElProps(refItems.current, item && item.fields);
    }, []);
    var setActiveLink = function (i) {
        setItemIndex(i);
        //moveUpMobile(i);
        setTimeout(function () {
            if (window.innerWidth < 768) {
                var navBar = document.getElementById("navbar");
                //console.log(refItems.current.getBoundingClientRect().top);
                var scrollOffset = refItems.current.getBoundingClientRect().top - (navBar ? navBar.offsetHeight : 0);
                window.scrollBy({ top: scrollOffset, behavior: 'smooth' });
                //refItems.current?.scrollIntoView({
                //    behavior: 'smooth'
                //})
            }
        }, 500);
    };
    return (React.createElement("li", { className: "nav-item", ref: refItems, "data-triggerclicktargetaftergeoinit": index == 0 ? ("#item" + item.id) : "" },
        React.createElement("div", { id: "#item" + item.id, className: "item-title" + (itemIndex === index ? " active" : ""), onClick: function () { setActiveLink(index); } },
            React.createElement(TextMediaAccordionItemTitle, { item: item, i: index, itemIndex: itemIndex })),
        React.createElement(Collapse, { isOpen: itemIndex === index },
            React.createElement("div", { className: "accordion-image d-block d-md-none my-4" },
                React.createElement("div", { className: "accordion-img-container active" },
                    React.createElement(BgTransitionAnimation, { color1: item.fields.color1, color2: item.fields.color2, navigationState: itemIndex === index ? "loading" : "idle" }),
                    React.createElement("img", { src: item.fields.image, alt: item.fields.image_description ? item.fields.image_description : "FlyOver", className: "flyout-accordion-image active" }))),
            React.createElement(TextMediaAccordionItemContent, { item: item, i: index }))));
}
